import { useMemo } from 'react';
import { BRAND_CONFIGS } from '../config/index.js';

/**
 * Retourne la config marque à partir du hostname (logique pure pour testabilité).
 * @param {string} hostname
 * @returns {object|null}
 */
export function getBrandFromHostname(hostname) {
  if (hostname.includes('audi')) return BRAND_CONFIGS.audi;
  if (hostname.includes('skoda')) return BRAND_CONFIGS.skoda;
  if (hostname.includes('cupra')) return BRAND_CONFIGS.cupra;
  if (hostname.includes('seat')) return BRAND_CONFIGS.seat;
  if (hostname.includes('volkswagen-utilitaires')) return BRAND_CONFIGS.vwu;
  if (hostname.includes('volkswagen')) return BRAND_CONFIGS.vw;
  return null;
}

export const useBrand = () => {
  const brandConfig = useMemo(
    () => getBrandFromHostname(globalThis.location.hostname),
    [],
  );
  return brandConfig;
};
